export { default } from './ProfileAccount';
